export default __webpack_public_path__ + "static/media/Purple-corporate-graphic.ee62f07d.svg";